<template>
  <div class="login-form">
    <div class="login-form__title">Восстановление пароля</div>
    
    <div v-if="!emailSent">
      <p class="text-center text-muted mb-4">
        Введите адрес электронной почты, на который будет отправлена ссылка для восстановления пароля.
      </p>
      
      <b-form @submit.prevent="onSubmit">
        <b-form-group label="Адрес электронной почты:">
          <b-form-input 
            v-model="email" 
            type="email" 
            required
            :disabled="loading"
            placeholder="Введите ваш email"
          ></b-form-input>
        </b-form-group>

        <b-overlay class="mt-5" :show="loading">
          <button
            :class="{ disable: disableButton }"
            type="submit"
            class="login-form__submit"
            :disabled="disableButton || loading"
          >
            <span v-if="loading">Отправка...</span>
            <span v-else>Отправить ссылку</span>
          </button>
        </b-overlay>
      </b-form>
    </div>

    <div v-else class="text-center">
      <div class="mb-3">
        <b-icon icon="check-circle-fill" variant="success" font-scale="3"></b-icon>
      </div>
      <h5 class="text-success mb-3">Письмо отправлено!</h5>
      <p class="text-muted mb-2">
        На адрес <strong>{{ email }}</strong> отправлена ссылка для восстановления пароля.
      </p>
      <p class="text-muted small">
        Если письмо не пришло в течение 5 минут, проверьте папку "Спам" или попробуйте еще раз.
      </p>
    </div>

    <div class="text-center mt-4">
      <b-link @click="$emit('back-to-login')" class="text-primary">
        ← Вернуться к авторизации
      </b-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PasswordResetForm',
  data() {
    return {
      email: "",
      loading: false,
      emailSent: false,
    };
  },

  computed: {
    disableButton() {
      return !this.email || !this.isValidEmail(this.email);
    },
  },

  methods: {
    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },

    async onSubmit() {
      if (this.disableButton || this.loading) return;

      this.loading = true;

      try {
        const response = await api.call('post', '/api/password/forgot', {
          email: this.email
        });

        if (response.status === 200) {
          this.emailSent = true;
          this.$toast.success('Ссылка для восстановления пароля отправлена на ваш email!', {
            position: "top-center",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: false,
            pauseOnHover: false,
            draggable: true,
            draggablePercent: 1,
            showCloseButtonOnHover: true,
            hideProgressBar: true,
            closeButton: "button",
            icon: "fa fa-check-circle",
            rtl: false,
          });
        }
      } catch (error) {
        console.error('Password reset error:', error);
        
        let errorMessage = 'Произошла ошибка при отправке письма. Попробуйте еще раз.';
        
        if (error.response && error.response.data) {
          if (error.response.data.message) {
            errorMessage = error.response.data.message;
          } else if (error.response.data.error) {
            errorMessage = error.response.data.error;
          }
        }

        this.$toast.error(errorMessage, {
          position: "top-center",
          timeout: 5000,
          closeOnClick: true,
          pauseOnFocusLoss: false,
          pauseOnHover: false,
          draggable: true,
          draggablePercent: 1,
          showCloseButtonOnHover: true,
          hideProgressBar: true,
          closeButton: "button",
          icon: "fa fa-exclamation-triangle",
          rtl: false,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

